import { S3_IMAGES_URL, S3_AUDIO_URL, ANIMATION_URL } from '../config';

export const replaceWithAbsolutePath = (text) => {
    if (!text) {
        return text;
    }

    return text.replace(/<img.*?src="(?!http)\/?/g, (match) => match.replace(/src="\/?/, `src="${S3_IMAGES_URL}/`));
};

export const replaceImagePath = (src) => {
    if (!src || src.toLowerCase().startsWith('http')) {
        return src;
    }

    return `${S3_IMAGES_URL}/${src}`;
};

export const replaceAnimationPath = (src) => {
    if (!src || src.toLowerCase().startsWith('http')) {
        return src;
    }

    return `${ANIMATION_URL}/${src}`;
};

export const replaceAttachmentsPath = (text) => {
    if (!text || text.toLowerCase().startsWith('http')) {
        return text;
    }

    return `${S3_AUDIO_URL}/${text}`;
};
